module.exports = __webpack_public_path__ + "img/IMG_1962_P_Foamcore.9ab2e571.jpg";